import React from 'react';
import Icon from '../../../components/AppIcon';

const LiveUpdateCard = ({ update, onDismiss }) => {
  const getUpdateIcon = (type) => {
    switch (type) {
      case 'rank_change':
        return 'TrendingUp';
      case 'points_update':
        return 'Award';
      case 'match_update':
        return 'Activity';
      case 'tournament_update':
        return 'Trophy';
      default:
        return 'Bell';
    }
  };

  const getUpdateColor = (type) => {
    switch (type) {
      case 'rank_change':
        return update?.rankChange > 0 ? 'text-green-600' : 'text-orange-600';
      case 'points_update':
        return 'text-blue-600';
      case 'match_update':
        return 'text-purple-600';
      case 'tournament_update':
        return 'text-indigo-600';
      default:
        return 'text-gray-600';
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInSeconds = Math.floor((now - date) / 1000);

    if (diffInSeconds < 60) return 'Just now';
    if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
    if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
    return date?.toLocaleDateString();
  };

  return (
    <div className="bg-gradient-to-r from-primary/5 to-primary/10 border-l-4 border-primary rounded-lg p-4 shadow-sm animate-slide-in-right">
      <div className="flex items-start gap-3">
        <div className={`p-2 rounded-full bg-white ${getUpdateColor(update?.type)}`}>
          <Icon name={getUpdateIcon(update?.type)} size={20} />
        </div>
        
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {update?.title}
              </h4>
              <p className="text-sm text-muted-foreground">
                {update?.message}
              </p>
              
              {update?.type === 'rank_change' && (
                <div className="mt-2 flex items-center gap-4 text-xs">
                  <span className="flex items-center gap-1">
                    <Icon name="Hash" size={12} />
                    <span className="font-medium">Rank: {update?.newRank}</span>
                  </span>
                  {update?.rankChange !== 0 && (
                    <span className={`flex items-center gap-1 font-medium ${
                      update?.rankChange > 0 ? 'text-green-600' : 'text-orange-600'
                    }`}>
                      <Icon 
                        name={update?.rankChange > 0 ? 'ArrowUp' : 'ArrowDown'} 
                        size={12} 
                      />
                      {Math.abs(update?.rankChange)} position{Math.abs(update?.rankChange) > 1 ? 's' : ''}
                    </span>
                  )}
                </div>
              )}
              
              {update?.type === 'points_update' && (
                <div className="mt-2 flex items-center gap-4 text-xs">
                  <span className="flex items-center gap-1">
                    <Icon name="Award" size={12} />
                    <span className="font-medium">{update?.newPoints} pts</span>
                  </span>
                  {update?.pointsGained > 0 && (
                    <span className="flex items-center gap-1 text-green-600 font-medium">
                      <Icon name="Plus" size={12} />
                      {update?.pointsGained} pts
                    </span>
                  )}
                </div>
              )}
            </div>
            
            <button
              onClick={() => onDismiss?.(update?.id)}
              className="p-1 hover:bg-white/50 rounded transition-colors flex-shrink-0"
              aria-label="Dismiss update"
            >
              <Icon name="X" size={16} className="text-muted-foreground" />
            </button>
          </div>
          
          <div className="mt-2 flex items-center gap-2">
            <span className="inline-flex items-center gap-1 px-2 py-1 bg-white rounded-full text-xs text-muted-foreground">
              <Icon name="Zap" size={10} />
              Live
            </span>
            <span className="text-xs text-muted-foreground">
              {formatTimestamp(update?.timestamp)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveUpdateCard;
